const flow = require('lodash/fp/flow');
const reject = require('lodash/fp/reject');
const map = require('lodash/fp/map');
const set = require('lodash/fp/set');
const { placeholder: _ } = require('lodash/fp/curry');


function InactiveSubscriptionsController(subscriptionService, productService, $q) {
  const ctrl = this;

  const expandProduct = obj => productService.get(obj.productId, { cache: true }).then(set('product', _, obj));

  ctrl.init = function() {
    if (!ctrl.loadingItems) {
      ctrl.loadingItems = true;

      return subscriptionService.getAll({ live: false, pagination: { pageSize: 100 } })
        .then(flow(
          reject('extraData.hide'),
          map(expandProduct),
          $q.all.bind($q)
        ))
        .then((remaining) => {
          ctrl.subscriptions = remaining;
        })
        .finally(() => {
          ctrl.loadingItems = false;
        });
    }

    return undefined;
  };

  ctrl.init();
}

InactiveSubscriptionsController.$inject = ['ogsdk.subscriptionService', 'ogsdk.productService', '$q'];

angular.module('msi.subscriptions')
  .controller('InactiveSubscriptionsController', InactiveSubscriptionsController);

module.exports = InactiveSubscriptionsController;
